/*!
 * Copyright © 2020-2025. Verizon Connect Ireland Limited. All rights reserved.
 */

import { ActionReducerMap } from '@ngrx/store';

import { IAccountState } from '../state';
import { userReducer } from './user.reducer';

export const accountReducers: ActionReducerMap<IAccountState> = {
  user: userReducer
};
